<template>
  <div class="container-fluid h-100">
    <div class="content-detail-comercial" id="contentCommercial">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-md-12 col-lg-5 col-xl-5">
          <div>
            <div
              class="row justify-content-center justify-content-sm-center justify-content-md-center"
            >
              <template v-if="loading.profile">
                <div
                  class="spinner-border text-light"
                  style="width: 5rem; height: 5rem;"
                  role="status"
                >
                  <span class="sr-only">Loading...</span>
                </div>
              </template>
              <template v-else>
                <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                  <h1 class="title-profile-1">
                    {{ dataUser.name }} {{ dataUser.last_name }}
                  </h1>
                </div>
                <!--       <div class="col-12 col-md-12 col-lg-12 col-xl-12" style="text-align: left">
                                    <label style="font-size: 20px;">
                                        {{ documentUser }} {{ dataUser.document_number }}</label>

                                </div>
                                <div class="col-12 col-md-12 col-lg-12 col-xl-12" style="text-align: left">

                                    <label style="font-size: 20px;">TEL: {{ dataUser.phone }}</label>
                                </div>
                                <div class="col-12 col-md-12 col-lg-12 col-xl-12" style="text-align: left">
                                    <label style="font-size: 20px;"> {{ dataUser.email }}</label>
                                </div>-->
              </template>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-7 col-xl-7">
          <template v-if="loading.table">
            <div
              class="spinner-border text-danger"
              style="width: 5rem; height: 5rem;"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </template>
          <template v-else>
            <ul
              class="nav nav-tabs tab-commercial nav-pills nav-fill"
              id="myTab"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="home-tab"
                  data-toggle="tab"
                  href="#home"
                  role="tab"
                  aria-controls="home"
                  aria-selected="true"
                  @click="showMenu(0)"
                  >Lubricadores inscritos</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link"
                  id="profile-tab"
                  data-toggle="tab"
                  href="#profile"
                  role="tab"
                  aria-controls="profile"
                  aria-selected="false"
                  @click="showMenu(1)"
                  >Nuevo lubricador</a
                >
              </li>
              <!--        <li class="nav-item" role="presentation">
                                <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab"
                                    aria-controls="contact" aria-selected="false" @click="showMenu(2)">Tapas
                                    suscritas</a>
                            </li>-->
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                style="background-color: #9e9e9e40"
                class=" tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <paginate
                  class="ul-pagination-c mr-3 ml-3"
                  name="items"
                  :list="items"
                  :per="9"
                >
                  <div class="table-responsive">
                    <table
                      class="mt-4 table table-sm table-commercial table-striped"
                    >
                    <caption class="visually-hidden">Listado de Usuarios</caption>
                      <thead>
                        <tr>
                          <th class="td-commercial" scope="col">Nombre</th>
                          <th class="td-commercial" scope="col">Correo</th>
                          <th class="td-commercial" scope="col">
                            Identificación
                          </th>
                          <!-- <th class="td-commercial" scope="col">Estado</th> -->
                          <th class="td-commercial" scope="col">
                            Estado de cuenta
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, k) in paginated('items')"
                          :key="`item-${k}`"
                        >
                          <th class="td-commercial" scope="row">
                            {{ data.name }} {{ data.last_name }}
                          </th>
                          <td class="td-commercial">{{ data.email }}</td>
                          <td class="td-commercial">
                            {{ data.document_number }}
                          </td>
                          <!-- <td class="td-commercial">
                            <template v-if="data.caps.length > 0">
                              <h5>
                                <span class="badge badge-danger">{{
                                  data.caps.length
                                }}</span>
                              </h5>
                            </template>
                            <template v-else>
                              <h5>
                                <span class="badge badge-secondary">{{
                                  data.caps.length
                                }}</span>
                              </h5>
                            </template>
                          </td> -->
                          <td>
                            <i
                              style="cursor: pointer;"
                              class="fa fa-eye fa-lg text-danger"
                              @click="openModalAccount(data.id)"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <!-- <td>
                            <i
                              style="cursor: pointer;"
                              class="fa fa-eye fa-lg text-danger"
                              @click="IrDetails(data.id)"
                              aria-hidden="true"
                            ></i>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </paginate>
                <div class="row justify-content-center">
                  <div
                    class="col-12 col-md-9 col-lg-2 col-xl-2 col-sm-12  center-paginate"
                  >
                    <div style="text-align: center">
                      <paginate-links
                        @change="pageChange"
                        for="items"
                        :limit="2"
                        :show-step-links="true"
                        :step-links="{ next: '>', prev: '<' }"
                        :classes="{
                          ul: 'pagination',
                          li: 'page-item-c',
                          a: 'page-link',
                        }"
                      >
                      </paginate-links>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="profile"
                style="background-color: #9e9e9e40"
                role="tabpanel"
                aria-labelledby="profile-tab"
              >
                <div class="row pt-4">
                  <div class="col-12 small-info">
                    <small>Recuerda que los datos marcados con (*) son obligatorios</small>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3 ">
                        <select
                          v-model="form.documentType"
                          class="form-control color-input select-input"
                          :class="{ 'is-danger': errors.documentType }"
                          id="exampleFormControlSelect1"
                          placeholder="Tipo de documento *"
                        >
                          <option value="0" disabled selected
                            >Tipo de documento *</option
                          >
                          <option
                            v-for="(item, i) in listTypeDocuments"
                            :key="'td' + i"
                            :value="item.id"
                            class="color-option"
                            >{{ item.name }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-if="errors.documentType"
                        class="text-danger float-left small error-danger"
                        >{{ errors.documentType }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group  mb-3">
                        <input
                          v-model="form.documentNumber"
                          type="text"
                          class="form-control color-input"
                          :class="{ 'is-danger': errors.documentNumber }"
                          aria-label="document"
                          placeholder="Número de documento * "
                          aria-describedby="basic-addon1"
                        />
                      </div>
                      <span
                        v-if="errors.documentNumber"
                        class="text-danger float-left small error-danger"
                        >{{ errors.documentNumber }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :class="{ 'is-danger': errors.name }"
                          v-model="form.name"
                          type="text"
                          class="form-control color-input"
                          aria-label="name"
                          placeholder="Nombres *"
                          aria-describedby="basic-addon1"
                        />
                      </div>
                      <span
                        v-if="errors.name"
                        class="text-danger float-left small error-danger"
                        >{{ errors.name }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :class="{ 'is-danger': errors.lastName }"
                          v-model="form.lastName"
                          type="text"
                          class="form-control color-input"
                          aria-label="lastName"
                          placeholder="Apellidos *"
                          aria-describedby="basic-addon1"
                        />
                      </div>
                      <span
                        v-if="errors.lastName"
                        class="text-danger float-left small error-danger"
                        >{{ errors.lastName }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group  mb-3">
                        <select
                          v-model="form.state"
                          class="form-control color-input select-input"
                          :class="{ 'is-danger': errors.state }"
                          id="exampleFormControlSelect1"
                        >
                          <option disabled value="0" selected
                            >Departamento *</option
                          >
                          <option
                            v-for="(item, i) in listDocuments"
                            :value="item.id"
                            class=" color-option"
                            :key="'st' + i"
                            >{{ item.name }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-if="errors.state"
                        class="text-danger float-left small error-danger"
                        >{{ errors.state }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <select
                          v-model="form.cityId"
                          :disabled="showCities"
                          class="form-control color-input select-input"
                          :class="{ 'is-danger': errors.cityId }"
                          id="exampleFormControlSelect1"
                        >
                          <option value="0" disabled selected>Ciudad *</option>
                          <option
                            v-for="(item, i) in listCities"
                            :key="'ci' + i"
                            :value="item.id"
                            class=" color-option"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-if="errors.cityId"
                        class="text-danger float-left small error-danger"
                        >{{ errors.cityId }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :class="{ 'is-danger': errors.phone }"
                          type="text"
                          v-model="form.phone"
                          class="form-control color-input"
                          aria-label="phone"
                          placeholder="Teléfono *"
                          aria-describedby="basic-addon1"
                        />
                      </div>
                      <span
                        v-if="errors.phone"
                        class="text-danger float-left small error-danger"
                        >{{ errors.phone }}</span
                      >
                    </div>
                  </div>
                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :class="{ 'is-danger': errors.email }"
                          v-model="form.email"
                          type="text"
                          class="form-control color-input"
                          aria-label="email"
                          placeholder="email *"
                          aria-describedby="basic-addon1"
                        />
                      </div>
                      <span
                        v-if="errors.email"
                        class="text-danger float-left small error-danger"
                        >{{ errors.email }}</span
                      >
                    </div>
                  </div>

                  <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <input
                          :class="{ 'is-danger': errors.birthdate }"
                          type="text"
                          v-model="form.birthdate"
                          class="form-control color-input"
                          placeholder="fecha de nacimiento *"
                          :min="minDate()"
                          :max="maxDate()"
                          onfocus="(this.type='date')"
                        />
                      </div>
                      <span
                        v-if="errors.birthdate"
                        class="text-danger float-left small error-danger"
                        >{{ errors.birthdate }}</span
                      >
                    </div>
                  </div>

                  <div
                    class="mb-4 col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12"
                  >
                    <button
                      :disabled="disableLoading"
                      type="button"
                      @click="saveUserLubricator()"
                      class="btn btn-danger btn-sm btn-block btn-register"
                      id="btn-register-id"
                    >
                      <span
                        v-if="disableLoading"
                        class="spinner-border spinner-border-md"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <template v-else>Realizar Registro</template>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="contact"
                style="background-color: #9e9e9e40"
                role="tabpanel"
                aria-labelledby="contact-tab"
              >
                <listHistory :list="itemsHistory"></listHistory>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- MODAL ESTADO DE CUENTA -->
    <div
      class="modal fade"
      id="account-state"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l" style="border-radius: 50px;">
          <div class="modal-body img-account">
            <!-- <div class="boton">
              <button
                type="button"
                class="close close-info-l"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div> -->
            <div class="row justify-content-center">
              <div class="div-account">
                <h4 class="text-danger mb-0">
                  <span><strong>ESTADO DE CUENTA</strong></span>
                </h4>
              </div>

              <div
                class="col-12 col-sm-8 col-md-9 col-lg-8 col-xl-8 mb-0 mb-xl-5 mb-lg-5 mt-0 mt-xl-5 mt-lg-5"
              >
                <div class="row mt-4 ">
                  <div class="col-12 col-sm-2 col-md-12 col-lg-2 col-xl-2">
                    <p style="text-align: initial;" class="mt-2">
                      <span><strong>DESDE:</strong></span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.monthFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">MES</option>
                        <option
                          :key="data.num"
                          v-for="data in monthFrom"
                          :value="data.num"
                        >
                          {{ data.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.dayFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">DÍA</option>
                        <option
                          :key="data"
                          v-for="data in dayFrom"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.yearFrom"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">AÑO</option>
                        <option
                          :key="data"
                          v-for="data in yearFrom"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12 col-sm-2 col-md-12 col-lg-2 col-xl-2 ">
                    <p style="text-align: initial;" class="mt-2">
                      <span><strong>HASTA:</strong></span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.monthUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">MES</option>
                        <option
                          :key="data.num"
                          v-for="data in monthUntil"
                          :value="data.num"
                        >
                          {{ data.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.dayUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">DÍA</option>
                        <option
                          :key="data"
                          v-for="data in dayUntil"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-12 col-sm-3 col-md-4 col-lg-3 col-xl-3">
                    <div class="form-group">
                      <select
                        v-model="infoAccount.yearUntil"
                        class="form-control"
                        id="exampleFormControlSelect1"
                      >
                        <option selected disabled value="null">AÑO</option>
                        <option
                          :key="data"
                          v-for="data in yearUntil"
                          :value="data"
                        >
                          {{ data }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                <button @click="getAccount()" class="btn btn-get-black">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Buscar
                  </template>
                </button>
              </div>

              <!-- <div class="col-12 mt-2 mb-4">
                <button @click="downloadAccount()" class="btn btn-down-yellow">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Descargar
                  </template>
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL ESTADO DE CUENTA TABLA -->
    <div
      class="modal fade"
      id="account-state-get"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content modal-info-l" style="border-radius: 50px;">
          <div class="modal-body img-account">
            <!-- <div class="boton">
              <button
                type="button"
                class="close close-info-l"
                data-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div> -->
            <div class="row justify-content-center">
              <div class="div-account">
                <h4 class="text-danger mb-0">
                  <span><strong>ESTADO DE CUENTA</strong></span>
                </h4>
              </div>
            </div>

            <div class="row justify-content-center mt-5">
              <div class="col-11 table-account">
                <template v-if="loading.listA">
                  <div class="pr-5 pt-5" style="text-align: center">
                    <div
                      class="spinner-border text-danger"
                      style="width: 5rem; height: 5rem;"
                      role="status"
                    ></div>
                  </div>
                </template>

                <div v-else class="table-responsive">
                  <table class="table table-sm table-account-t">
                    <caption class="visually-hidden">Historial</caption>
                    <thead>
                      <tr>
                        <th class="th-account-1" scope="col">Fecha</th>
                        <th class="th-account" scope="col">
                          Ingreso de códigos
                        </th>
                        <th class="th-account-1" scope="col">
                          Egreso redenciones
                        </th>
                        <th class="th-account" scope="col">Detalle</th>
                        <th class="th-account-1" scope="col">
                          Estado redenciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="data in listAccount" :key="data.id">
                        <td scope="row">{{ data.date }}</td>
                        <td>{{ data.total_codes }}</td>
                        <td>{{ data.total_redeems }}</td>
                        <td>{{ data.detail }}</td>
                        <td>{{ data.status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-12 mt-5 mb-4">
                <!-- <button @click="downloadAccount()" class="btn btn-down-yellow">
                  <template v-if="loading.btn">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </template>
                  <template v-else>
                    Descargar
                  </template>
                </button> -->
                <button @click="closeModal()" class="btn btn-down-yellow">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DATE } from "../../../config/utils";
import listHistory from "./listHistory.vue";
import axios from 'axios';
import $ from "jquery";

export default {
  components: {
    listHistory: listHistory,
  },
  data() {
    return {
      lubricatorId: null,
      infoAccount: {
        monthFrom: null,
        dayFrom: null,
        yearFrom: null,
        monthUntil: null,
        dayUntil: null,
        yearUntil: null,
      },
      listAccount: [],
      monthFrom: DATE.month,
      dayFrom: DATE.day,
      yearFrom: DATE.year,
      monthUntil: DATE.month,
      dayUntil: DATE.day,
      yearUntil: DATE.year,
      disableLoading: false,
      showCities: true,
      listCities: [],
      listDocuments: [],
      listTypeDocuments: [],
      form: {
        state: 0,
        cityId: 0,
        documentType: 0,
        documentNumber: "",
        name: "",
        lastName: "",
        phone: "",
        email: "",
        birthdate: null,
      },
      errors: {
        state: false,
        cityId: false,
        documentType: false,
        documentNumber: false,
        name: false,
        lastName: false,
        phone: false,
        email: false,
        birthdate: false,
      },
      hidden: {
        history: true,
        table: true,
      },
      loading: {
        profile: false,
        table: false,
      },
      items: [],
      paginate: ["items"],
      page: 1,
      totalPage: 1,
      itemsHistory: [],
      dataUser: {},
      documentUser: {},
    };
  },
  watch: {
    "form.state": function(n) {
      this.getCities(n);
      if (n == 0) {
        this.errors.state = "El departamento es requerido.";
      } else {
        this.errors.state = false;
      }
    },
    "form.cityId": function(n) {
      if (n != 0) {
        this.errors.cityId = false;
      } else {
        this.errors.cityId = "La ciudad es requerida.";
      }
    },
    "form.documentType": function(n) {
      if (n != 0) {
        this.errors.documentType = false;
      } else {
        this.errors.documentType = "El tipo de documento es requerido.";
      }
    },
    "form.documentNumber": function(n) {
      if (n) {
        this.errors.documentNumber = false;
      } else {
        this.errors.documentNumber = "El número de documento es requerido.";
      }
    },
    "form.name": function(n) {
      if (n) {
        this.errors.name = false;
      } else {
        this.errors.name = "Los nombres son requeridos.";
      }
    },
    "form.lastName": function(n) {
      if (n) {
        this.errors.lastName = false;
      } else {
        this.errors.lastName = "Los apellido son requeridos.";
      }
    },
    "form.phone": function(n) {
      if (!n) {
        this.errors.phone = "El teléfono es requerido.";
      } else if (!this.validPhone(n)) {
        this.errors.phone = "El teléfono es inválido.";
      } else {
        this.errors.phone = false;
      }
    },
    "form.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.birthdate": function(n) {
      if (n) {
        this.errors.birthdate = false;
      } else {
        this.errors.birthdate = "La fecha de nacimiento es requerida.";
      }
    },
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    openModalAccount(id) {
      this.lubricatorId = id;
      $("#account-state").modal("show");
    },
    getAccount() {
      if (
        this.infoAccount.monthFrom == null &&
        this.infoAccount.yearFrom == null &&
        this.infoAccount.dayFrom == null &&
        this.infoAccount.yearUntil == null &&
        this.infoAccount.monthUntil == null &&
        this.infoAccount.dayUntilFrom == null
      ) {
        this.$swal({
          icon: "warning",
          title: "Oops...",
          text: "Debes seleccionar una fecha",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }

      var data = {
        userId: this.lubricatorId,
        initDate:
          this.infoAccount.yearFrom +
          "-" +
          this.infoAccount.monthFrom +
          "-" +
          this.infoAccount.dayFrom,
        finDate:
          this.infoAccount.yearUntil +
          "-" +
          this.infoAccount.monthUntil +
          "-" +
          this.infoAccount.dayUntil,
      };
      this.loading.btn = true;
      axios
        .post("api/statement/account/lubricator", data)
        .then((res) => {
          this.loading.btn = false;
          this.listAccount = [];
          // console.log(res);
          if (res.data.cod == 0) {
            $("#account-state-get").modal("show");
            $("#account-state").modal("hide");
            this.listAccount = res.data.data;
          }
        })
        .catch((error) => {
          this.closeModal();
          this.loading.btn = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    closeModal() {
      $("#account-state-get").modal("hide");
    },
    downloadAccount() {
      if (
        this.infoAccount.monthFrom == null &&
        this.infoAccount.yearFrom == null &&
        this.infoAccount.dayFrom == null &&
        this.infoAccount.yearUntil == null &&
        this.infoAccount.monthUntil == null &&
        this.infoAccount.dayUntilFrom == null
      ) {
        this.$swal({
          icon: "warning",
          title: "Oops...",
          text: "Debes seleccionar una fecha",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      var data = {
        userId: this.lubricatorId,
        initDate:
          this.infoAccount.yearFrom +
          "-" +
          this.infoAccount.monthFrom +
          "-" +
          this.infoAccount.dayFrom,
        finDate:
          this.infoAccount.yearUntil +
          "-" +
          this.infoAccount.monthUntil +
          "-" +
          this.infoAccount.dayUntil,
        origin: 2
      };
      this.loading.btn = true;

      this.$swal({
        confirmButtonColor: "#dc3545",
        icon: "info",
        title: "Info",
        text: "La descarga se esta iniciando, por favor espere un momento",
      });

      axios
        .post("api/download/lubricator", data, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          this.loading.btn = false;
          const file = new Blob([res.data], {
            type: "application/pdf;charset=utf-8;",
          });
          const fileURL = URL.createObjectURL(file);
          // console.log(fileURL);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download =
            "reporte-generado-" +
            new Date().toISOString().substr(0, 10) +
            ".pdf";
          link.click();
          this.disableLoading = false;
        })
        .catch((error) => {
          // console.log(error.response.status);
          this.loading.btn = false;
          var sms =
            "Hubo un error al descargar el archivo, contacte con el administrador ";
          if (error.response.status == 400) {
            sms = "Las fechas enviadas son inválidas ";
          }
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: sms,
          });
        });
    },
    validform() {
      let app = this;

      if (!app.form.documentType) {
        app.errors.documentType = "El tipo de documento es requerido.";
        return false;
      }
      if (!app.form.documentNumber) {
        app.errors.documentNumber = "El número de documento es requerido.";
        return false;
      }
      if (!app.form.name) {
        app.errors.name = "Los nombres son requeridos.";
        return false;
      }
      if (!app.form.lastName) {
        app.errors.lastName = "Los apellidos son requeridos.";
        return false;
      }
      if (!app.form.state) {
        app.errors.state = "El departamento es requerido.";
        return false;
      }
      if (!app.form.cityId) {
        app.errors.cityId = "La ciudad es requerida.";
        return false;
      }
      if (!app.form.phone) {
        app.errors.phone = "El número de teléfono es requerido.";
        return false;
      }
      if (!app.form.email) {
        app.errors.email = "El email es requerido.";
        return false;
      }
      if (!app.form.birthdate) {
        app.errors.birthdate = "La fecha de nacimiento es requerida.";
        return false;
      }
      if (
        !app.errors.state &&
        !app.errors.cityId &&
        !app.errors.documentType &&
        !app.errors.documentNumber &&
        !app.errors.name &&
        !app.errors.lastName &&
        !app.errors.phone &&
        !app.errors.email &&
        !app.errors.birthdate &&
        !app.validEmail(app.errors.email)
      ) {
        return true;
      }
      return false;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phone) {
      var re = /^[0-9]{7,10}$/;
      return re.test(phone);
    },
    saveUserLubricator() {
      if (this.validform()) {
        var app = this;
        this.disableLoading = true;
        axios
          .post("api/signupLubricator", app.form)
          .then(function(res) {
            if (res.data.cod == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.message,
              });
              app.$router.push({ name: "comercialProfile" });
              app.clearForm();
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
              });
            }
            app.disableLoading = false;
          })
          .catch(function(error) {
            console.log(error);
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: "Error al registrar la información",
            });
            app.disableLoading = false;
          });
      }
    },
    clearForm() {
      this.form = {
        state: 0,
        cityId: 0,
        documentType: 0,
        documentNumber: "",
        name: "",
        lastName: "",
        phone: "",
        email: "",
        birthdate: "",
      };
      setTimeout(() => (
        this.errors = {
          state: false,
          cityId: false,
          documentType: false,
          documentNumber: false,
          name: false,
          lastName: false,
          phone: false,
          email: false,
          birthdate: false,
        }),10);
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.showCities = false;
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    showMenu(type) {
      // 0 = Lista de lubricadores, 1 = Nuevo lubricador, 2 = Tapas suscritas
      switch (type) {
        case 1:
          break;
        case 2:
          this.getListRequest();
          break;

        default:
          this.getLubricator();
          break;
      }
    },
    getListRequest() {
      this.loading.table = true;
      axios
        .get("api/commercial/history")
        .then((res) => {
          if (res.data.cod == 0) {
            this.itemsHistory = res.data.data;
          }
          this.loading.table = false;
        })
        .catch(() => {
          this.loading.table = false;
        });
    },
    closeHistory() {
      this.hidden.history = true;
      this.getLubricator();
    },
    openHistory() {
      this.hidden.history = false;
      this.getListRequest();
    },
    IrDetails(id) {
      this.$router.push({ name: "detailsCommercial", params: { id: id } });
    },
    getDataUser() {
      var app = this;
      this.loading.profile = true;
      axios
        .get("api/showUser")
        .then(function(res) {
          app.dataUser = res.data.User;
          app.documentUser = res.data.User.document_type.name;
          app.cityUser = res.data.User.city.name;
          app.redeemCodes = res.data.Codes;
          app.points = res.data.Points;
          app.loading.profile = false;
        })
        .catch(function(error) {
          app.loading.profile = false;
          console.log(error);
        });
    },
    getLubricator() {
      this.loading.table = true;
      axios
        .get("api/commercial/listCaps")
        .then((res) => {
          console.log(res);
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.items.sort(function(a, b) {
              if (a.caps.length < b.caps.length) {
                return 1;
              }
              if (a.caps.length > b.caps.length) {
                return -1;
              }
              return 0;
            });
          }
          this.loading.table = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading.table = false;
        });
    },
    pageChange(toPage) {
      this.page = toPage;
    },
  },
  mounted() {
    this.getTypeDocuments();
    this.getListStates();
    this.getDataUser();
    this.getListRequest();
    this.getLubricator();
  },
};
</script>

<style scope>
.th-account-1 {
  background-color: #d82112;
  color: #fff;
}
.th-account {
  background-color: #f32918;
  color: #fff;
}
.table-account-t td:nth-child(1) {
  background-color: #e7e7e7;
}
.table-account-t td:nth-child(3) {
  background-color: #e7e7e7;
}
.table-account-t td:nth-child(5) {
  background-color: #e7e7e7;
}
.table-account {
  padding: 6px;
  background-color: #fff;
  height: 300px;
  overflow: auto;
}
.btn-get-black {
  background-color: #000;
  color: #fff;
  margin-top: 110px;
}
.btn-down-yellow {
  border-radius: 30px;
  background-color: #fdd200;
  color: #d82233;
  font-weight: bold;
  padding: 4px 50px 4px 50px;
}
.btn-down-yellow:hover {
  color: "#ffffff" !important;
}
.div-account {
  margin: 0px;
  padding: 3px 0px 3px 0px;
  background-color: #fff;
  width: 100%;
}
.img-account {
  border-radius: 22px;
  background-position: center;
  background-image: url("./../../../assets/img/infoLubricador.jpg");
}
ul.pagination {
  justify-content: center;
}
.table-commercial {
  border: 1px solid !important;
  border-color: #dee2e6 !important;
  background-color: #7d7d7d3d;
}
.tab-commercial {
  background-color: #7d7d7d3d !important;
}
.nav-pills .nav-link {
  background-color: #9e9e9e17;
  font-weight: bold;
  color: #fff;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #9e9e9e17;
  border-bottom: none !important;
}
.nav-pills {
  border-bottom: none;
}
.td-commercial {
  color: #fff;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: #0000007a !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.position-detail {
  text-align: left;
}
.page-item-c.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: white;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item-c.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.title-list-l {
  padding-top: 10%;
  padding-left: 5%;
  font-family: "GothamBoldItalic", sans-serif;
  color: #dc3545;
  text-align: left;
}
.content-detail-comercial {
  padding-right: 5%;
  padding-left: 5%;
  padding-top: 8%;
  padding-bottom: 8%;
  height: 100%;
}
#contentCommercial {
  background-size: cover;
  /* background-image: url("../../../assets/img/03.jpg"); */
  background-image: url("../../../assets/img/FOTO-4.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.title-profile-1 {
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left !important;
  font-size: 50px;
  font-display: swap;
}
.page-item-c:last-child .page-link {
  background-color: #f0f8ff00;
  color: #dc3545;
  border: none !important;
}
.page-item-c:first-child .page-link {
  background-color: #f0f8ff00;
  color: #dc3545;
  border: none !important;
}
.pd-icon-close {
  padding-top: 8% !important;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
}

/* TABLET */
@media (max-width: 1023px) {
}

/* MOBILE L */
@media (max-width: 767px) {
  .title-profile-1 {
    font-size: 45px;
  }
  .pd-icon-close {
    padding-top: 0px !important;
    padding-bottom: 10px;
  }
  .title-list-l {
    padding-left: 0%;
    font-size: 25px;
    text-align: center;
  }
  ul.ul-pagination-c {
    padding-inline-start: 0px;
  }
  .icon-img-svg-c {
    width: 34px;
    padding-top: 15px;
  }
  .icon-img-svg-c-phone {
    padding: 6px;
  }
  .content-detail-comercial {
    padding-left: 0%;
    padding-top: 10%;
    padding-bottom: 0%;
    height: 100%;
  }
}

/* MOBILE M */
@media (max-width: 375px) {
  .pd-icon-close {
    padding-top: 0px !important;
    padding-bottom: 10px;
  }
  .title-list-l {
    padding-left: 0%;
    font-size: 25px;
    text-align: center;
  }
  ul.ul-pagination-c {
    padding-inline-start: 0px;
  }
  .icon-img-svg-c {
    width: 34px;
    padding-top: 15px;
  }
  .icon-img-svg-c-phone {
    padding: 6px;
  }
  .content-detail-comercial {
    padding-left: 0%;
    padding-top: 10%;
    padding-bottom: 0%;
    height: 100%;
  }
}

/* MOBILE S */
@media (max-width: 320px) {
  .pd-icon-close {
    padding-top: 0px !important;
    padding-bottom: 10px;
  }
  .title-list-l {
    padding-left: 0%;
    font-size: 25px;
    text-align: center;
  }
  ul.ul-pagination-c {
    padding-inline-start: 0px;
  }
  .icon-img-svg-c {
    width: 34px;
    padding-top: 15px;
  }
  .icon-img-svg-c-phone {
    padding: 6px;
  }
  .content-detail-comercial {
    padding-left: 0%;
    padding-top: 10%;
    padding-bottom: 0%;
    height: 100%;
  }
}

@font-face {
  font-family: "ubuntu-bold";
  src: url("./../../../assets/font/Ubuntu-Bold.ttf");
  font-display: swap;
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>
